/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE: you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import { IgrGridColumnSortOptionsModule } from './igr-grid-column-sort-options-module';
import { IgrGridColumnMoveOptionsModule } from './igr-grid-column-move-options-module';
import { IgrGridColumnPinOptionsModule } from './igr-grid-column-pin-options-module';
import { IgrGridColumnHideOptionsModule } from './igr-grid-column-hide-options-module';
import { IgrGridColumnGroupOptionsModule } from './igr-grid-column-group-options-module';
import { IgrGridColumnFilterOptionsModule } from './igr-grid-column-filter-options-module';
import { IgrGridColumnOptions } from './igr-grid-column-options';
import { GridColumnOptions } from './GridColumnOptions';
import { TypeRegistrar } from "igniteui-react-core";
var IgrGridColumnOptionsModule = /** @class */ /*@__PURE__*/ (function () {
    function IgrGridColumnOptionsModule() {
    }
    IgrGridColumnOptionsModule.register = function () {
        IgrGridColumnSortOptionsModule.register();
        IgrGridColumnMoveOptionsModule.register();
        IgrGridColumnPinOptionsModule.register();
        IgrGridColumnHideOptionsModule.register();
        IgrGridColumnGroupOptionsModule.register();
        IgrGridColumnFilterOptionsModule.register();
        TypeRegistrar.registerCons('IgrGridColumnOptions', IgrGridColumnOptions);
        TypeRegistrar.registerCons('IgrGridColumnOptions', IgrGridColumnOptions);
        TypeRegistrar.register('GridColumnOptions', GridColumnOptions.$type);
    };
    return IgrGridColumnOptionsModule;
}());
export { IgrGridColumnOptionsModule };
//# sourceMappingURL=igr-grid-column-options-module.js.map
